import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

export const OrderNumberGeneratorButton = styled(Button)`
	flex: 1 0 auto;
	max-height: 4.5rem;

	body[dir='rtl'] & {
		max-height: 5.5rem;
	}
`;

export const AccordionContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 2rem;

	.accordion-content-container {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.products-buttons-form-item.form-item-content {
		display: flex;
		flex-direction: row;
		gap: 1rem;

		@media ${Breakpoints.mobile} {
			flex-direction: column;

			.button {
				width: 100%;
			}
		}
	}
`;

export const CustomHeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	color: var(--black);
	width: 100%;
`;

export const Required = styled.span`
	color: red;
`;
